import React from "react";

const PainelChamadas: React.FC = () => {
    const [text, setText] = React.useState("");

    const handleSpeak = () => {
        if ('speechSynthesis' in window) {
            const utterance = new SpeechSynthesisUtterance(text);
            utterance.lang = 'pt-BR';
            window.speechSynthesis.speak(utterance);
        } else {
            console.error("Navegador não suporta speech synthesis");
        }
    };

    return (
        <div className="w-full h-full bg-white p-10">
            <div className="flex flex-col gap-16">
                {/* Section 1: Painel de Chamadas */}
                <div className="flex items-center gap-32">
                    <div className="flex flex-col max-w-sm">
                        <h2 className="text-lg font-bold text-[#333]">Painel de Chamadas</h2>
                        <p className="text-[#888] mt-1 text-sm">
                            Abre o painel de chamadas para realizar
                            as triagens
                        </p>
                    </div>
                    <div>
                        <button
                            className="bg-[#005F8C] text-white font-medium py-2 px-8 rounded hover:bg-[#004a6e]"
                            onClick={() => window.open('/patio/operacoes_patio/painel_chamadas/board', '_blank', 'width=1280,height=720,noopener,noreferrer')}
                        >
                            Abrir
                        </button>
                    </div>
                </div>

                {/* Section 2: Sintetizador de Voz */}
                <div className="flex flex-col gap-4">
                    <h2 className="text-lg font-bold text-[#333]">Sintetizador de Voz</h2>
                    <div className="flex items-start gap-12">
                        <textarea
                            className="border border-gray-300 rounded p-2 w-72 h-44 resize-none focus:outline-none focus:border-[#005F8C]"
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        ></textarea>
                        <button
                            className="bg-[#005F8C] text-white font-medium py-2 px-8 rounded hover:bg-[#004a6e]"
                            onClick={handleSpeak}
                        >
                            Play
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PainelChamadas;
